import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiBuilding, FiPhone, FiMail, FiGlobe, FiFileText } = FiIcons;

const ImpressumScreen = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-4 pb-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiFileText} className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Impressum</h1>
          <p className="text-xl text-gray-600">Angaben gemäß § 5 TMG</p>
        </motion.div>

        {/* Main Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-3xl shadow-xl p-8"
        >
          {/* Company Information */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <SafeIcon icon={FiBuilding} className="w-6 h-6 mr-3 text-blue-500" />
              Internet Consulting Group Inc.
            </h2>
            <div className="text-gray-700 space-y-2">
              <p>304 S. Jones Blvd #3009</p>
              <p>Las Vegas NV 89107</p>
              <p>USA</p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Kontakt</h3>
            <div className="space-y-3">
              <div className="flex items-center text-gray-700">
                <SafeIcon icon={FiPhone} className="w-5 h-5 mr-3 text-green-500" />
                <span>Telefon: 1-239-645-4696</span>
              </div>
              <div className="flex items-center text-gray-700">
                <SafeIcon icon={FiMail} className="w-5 h-5 mr-3 text-blue-500" />
                <span>E-Mail: internetconsultinggroup@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Responsible Person */}
          <div className="mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h3>
            <div className="text-gray-700 space-y-2">
              <p>Internet Consulting Group Inc.</p>
              <p>304 S. Jones Blvd #3009</p>
              <p>Las Vegas NV 89107</p>
              <p>USA</p>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Haftungsausschluss</h3>
              
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3">Haftung für Inhalte</h4>
                <p className="text-gray-700 leading-relaxed">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
                  Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen 
                  zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder 
                  Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
                  erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen 
                  werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3">Haftung für Links</h4>
                <p className="text-gray-700 leading-relaxed">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese 
                  fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                  der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
                  Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten 
                  Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen 
                  werden wir derartige Links umgehend entfernen.
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-3">Urheberrecht</h4>
                <p className="text-gray-700 leading-relaxed">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
                  Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen 
                  der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, 
                  nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
                  Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine 
                  Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
                  werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>
            </div>
          </div>

          {/* Back Button */}
          <div className="mt-12 pt-6 border-t border-gray-200">
            <button
              onClick={onBack}
              className="inline-flex items-center space-x-2 text-gray-600 hover:text-gray-800 font-medium transition-colors duration-300"
            >
              <SafeIcon icon={FiArrowLeft} className="w-5 h-5" />
              <span>Zurück</span>
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ImpressumScreen;